<script>
import axios from "axios";
import { mapState ,mapActions } from "vuex";
import ModalBiblioteca from "@/components/intranet/biblioteca/ModalBiblioteca.vue";
import Loading from "@/components/layout/Loading.vue";
import SinResultados from "@/components/layout/SinResultados.vue";
import IconBiblioteca from "@/assets/img/icon/section/IconBiblioteca.vue";
export default {
  components: {
    ModalBiblioteca,
    Loading,
    SinResultados,
    IconBiblioteca
  },
  data() {
    return {
      categoriaSelected: "0",
      categoriaSelectedText: "Todas",
      url_documento_modal: "",
      nombre_documento_modal: "",
      nombre_buscar: "",
      id_modulo: "16",
      loadingBiblioteca: true,

      //FF
      filter: {
        search: "",
        categoria: { 
          id_categoria: "0", 
          nombre: "Todas" 
        }
      },
      heightWindow: 0
    };
  },
  computed:{
      ...mapState("BibliotecaModule", ["CategoriasDocumentos", "DocumentosBibliotecaPaginacion"]), 
  },
  created() {
    this.getDocumentoBiblioteca();
    this.getCategoriaBiblioteca();
  },
  mounted() {
    this.windowsHeight();
    window.addEventListener('resize', this.windowsHeight);
  },
  watch:{
    "filter.categoria" (){
      this.getDocumentoBiblioteca();
    },
    "filter.search"() {
      this.getDocumentoBiblioteca();
    }
  },
  methods: {
    ...mapActions("BibliotecaModule", ["getDocumentosBiblioteca", "getCategoriaDocumento"]),

    async getDocumentoBiblioteca(){
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_usuario: this.$ls.get("user").id_usuario,
        id_categoria: this.filter.categoria.id_categoria,
        id_modulo: this.id_modulo,
        plataforma: "1",
        nombre: this.filter.search,
        last_id: "999",
        limit: "16"
      }
      this.loadingBiblioteca = true;
      await this.getDocumentosBiblioteca(data_);
      this.loadingBiblioteca = false;
    },
    async getCategoriaBiblioteca(){
      let data_ = {
        id_empresa: this.$ls.get("user").id_empresa_fk,
        id_modulo: this.id_modulo,
      }
      await this.getCategoriaDocumento(data_);
    },
    changeCategoria(id, nombre) {
      this.categoriaSelected = id;
      this.categoriaSelectedText = nombre;
    },
    toDate(date) {
      const newDate = new Date(date);
      newDate.setDate(newDate.getDate() + 1);

      return newDate
        .toLocaleString("es-CL", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
        })
        .replace(/-/g, "/");
    },
    toTime(date) {
      const newDate = new Date(date);
      newDate.setDate(newDate.getDate() + 1);

      return newDate.toLocaleTimeString("es-CL", {
        hour: "numeric",
        minute: "numeric",
        hourCycle: "h12",
      });
    },
    changeFileModal(url, nombre) {
      this.url_documento_modal = url;
      this.nombre_documento_modal = nombre;
    },
    download(url, nombre) {
      axios
        .get(url, {
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/pdf" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = nombre;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch(console.error);
    },

    //FF
    windowsHeight() {
        let mediaQuery = window.matchMedia('(min-width: 992px)');
        let height = window.innerHeight;
        if (mediaQuery.matches) this.heightWindow = height -480 + "px";
        else this.heightWindow = "auto";
			},
  },
};
</script>

<template>
  <section id="biblioteca">

    <div class="row">
      <div class="col-12 mb-0">
        <h1 class="h1-custom font-700 mb-1 text-capitalize color-main d-flex align-items-center">
          <IconBiblioteca class="me-2 icon-svg-45"/>
          Biblioteca
        </h1>

        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link 
                to="/home"
                class="color-main"
              >
                <font-awesome-icon icon="fa-solid fa-house"></font-awesome-icon>
                Inicio
              </router-link>
            </li>
            <li class="breadcrumb-item text-capitalize active">
              Biblioteca
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="row d-flex mt-2">
      <div class="col-12 mb-3 mb-lg-0">
        <p class="text-secondary h5-custom mb-0">
          ¡Dile adiós al papeleo! Filtra por categoría, busca el documento que necesitas y descárgalo.
        </p>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="border-bottom mb-3 pb-3"></div>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 col-lg-3 input-display input-display-left mb-3 m-lg-0">
        <input 
          type="search" 
          class="form-control input-filter" 
          placeholder="Buscar"
          v-model="filter.search"
        >
        <font-awesome-icon icon="fa-solid fa-magnifying-glass" class="input-display-icon color-gray"></font-awesome-icon>
      </div>
      <div class="col-12 col-lg-3">
        <v-select
          :options="CategoriasDocumentos"
          v-model="filter.categoria"
          label="nombre"
          placeholder="Categorías"
          class="vue-select"
          :clearable="false"
        >
        </v-select>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mt-3">
        <Loading 
            v-if="loadingBiblioteca"
            pixeles="200px"
          />

        <SinResultados v-if="!loadingBiblioteca && DocumentosBibliotecaPaginacion.length === 0"/>

        <div class="table-container" v-if="!loadingBiblioteca">
          <table 
            v-if="DocumentosBibliotecaPaginacion.length > 0" 
            class="table table-custom table-custom-scroll table-borderless table-custom-responsive mb-0">
            <thead>
              <tr>
                <th scope="col">Nombre</th>
                <th scope="col" class="text-center">Tipo de archivo</th>
                <th scope="col">Categoria</th>
                <th scope="col">Última modificación</th>
                <th scope="col" class="text-lg-center xw-150"> Acciones</th>
              </tr>
            </thead>
            <tbody :style="`max-height: ${heightWindow}; min-height:150px;`">
              <tr v-for="(doc, k) in DocumentosBibliotecaPaginacion" :key="k">
                <td class="th th-nombre">
                  <span class="ellipsis-custom">{{ doc.nombre }}</span>
                </td>
                <td class="th th-tipo-archivo text-lg-center">
                  <h5 class="d-inline h5-custom">
                    <span class="badge border text-secondary font-400">
                      <font-awesome-icon icon="fa-solid fa-file" class="color-green"></font-awesome-icon>
                      {{ doc.url_documento.split(".")[doc.url_documento.split(".").length - 1]}}
                    </span>
                  </h5>
                </td>
                <td class="th th-categoria">
                  <span class="ellipsis-custom">{{ doc.categoria[0].nombre }}</span>
                </td>
                <td class="th th-fecha-subida">
                  <h5 class="d-inline h5-custom">
                    <span class="badge border text-secondary font-400 me-2 mb-1 mb-lg-0">
                      <font-awesome-icon icon="fa-solid fa-calendar"></font-awesome-icon>
                      {{ toDate(doc.fecha_creacion) }}
                    </span>
                    <span class="badge border text-secondary font-400">
                      <font-awesome-icon icon="fa-solid fa-clock"></font-awesome-icon>
                      {{ toTime(doc.fecha_creacion).replace("p.&nbsp;m.", "PM").replace("a.&nbsp;m.", "AM")}}
                    </span>
                  </h5>
                </td>
                <td class="th th-accion text-lg-center">
                  <div class="dropdown dropdown-custom d-flex justify-content-center">
                    <button 
                      class="dropdown-toggle dropdown-custom-action dropdown-custom-arrow-hide" 
                      type="button" 
                      data-bs-toggle="dropdown">
                      <font-awesome-icon icon="fa-solid fa-ellipsis-vertical"></font-awesome-icon>
                    </button>
                  <ul class="dropdown-menu card-shadow border-0">
                    <li>
                      <a 
                        @click="changeFileModal(doc.url_documento, doc.nombre)"
                        class="dropdown-item" 
                        data-bs-toggle="modal"
                        data-bs-target="#modal-archivo"
                        href="javascript:"
                      >
                        <font-awesome-icon icon="fa-solid fa-eye" class="color-main"></font-awesome-icon>
                        Vista previa
                      </a>
                    </li>
                    <li>
                      <a 
                        @click="download(doc.url_documento, doc.nombre)"
                        class="dropdown-item" 
                        href="javascript:">
                        <font-awesome-icon icon="fa-solid fa-download" class="color-main"></font-awesome-icon>
                        Descargar
                      </a>
                    </li>
                  </ul>
                </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div 
            v-if="DocumentosBibliotecaPaginacion.length == 0"
            class="alert alert-info mb-0">
            <font-awesome-icon icon="fa-solid fa-circle-info" class="pe-2"></font-awesome-icon>
            Agrega tus documentos de seguridad.
          </div>

        </div>
      </div>
    </div>

    <ModalBiblioteca
      :url_documento="url_documento_modal"
      :nombre_documento="nombre_documento_modal"
    />

  </section>
</template>